import { atom } from "jotai";

/**
 * Global open-state for the GitHub-style sync review modal.
 *
 * The modal is mounted once at the top of the app (in the Menubar
 * component, which wraps every page) so the menubar's "2 to push"
 * pill and the connection-restored toast can pop it open from
 * anywhere — the user shouldn't have to navigate to the Cloud sync
 * tab just to review pending work.
 *
 * The Cloud sync page's "Sync now" button writes to the same atom
 * so there's one and only one modal instance, and any caller can
 * open / close it without prop-drilling.
 */
export const syncModalOpenAtom = atom(false);

/**
 * Bump-counter atom that anything which mutates sync state writes
 * to. The menubar pill and other pending/dirty surfaces watch this
 * and re-poll their counts immediately instead of waiting for the
 * next 30s tick. Avoids the stale "2 to push" that lingers right
 * after Apply succeeds.
 */
export const syncStateRevAtom = atom(0);
